export default "__VITE_ASSET__CY4zPrGx__"